
import { Label } from "@/components/ui/label"
import { Input } from "@/components/ui/input"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { officeTypes } from "@/constants/documentTypes"

interface OfficeFieldsProps {
  recipient: string
  officeType?: string
  onChange: (field: string, value: string) => void
}

export function OfficeFields({ recipient, officeType, onChange }: OfficeFieldsProps) {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="recipient" className="text-sm font-medium text-gray-700">
          Destinatário
        </Label>
        <Input
          id="recipient"
          value={recipient}
          onChange={(e) => onChange("recipient", e.target.value)}
          className="border-gray-200 focus:ring-primary/20"
          placeholder="Digite o nome do destinatário"
        />
      </div>

      <div className="space-y-2">
        <Label className="text-sm font-medium text-gray-700 after:content-['*'] after:ml-0.5 after:text-red-500">
          Tipo de Ofício
        </Label>
        <Select
          value={officeType}
          onValueChange={(value) => onChange("officeType", value)}
          required
        >
          <SelectTrigger className="w-full border-gray-200 focus:ring-primary/20">
            <SelectValue placeholder="Selecione o tipo de ofício" />
          </SelectTrigger>
          <SelectContent className="max-h-[200px] overflow-y-auto">
            {officeTypes.map((type) => (
              <SelectItem key={type} value={type}>
                {type}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </>
  )
}
